import createHttpClient from "../../utils/httpClient/httpClient";

const daClient = ({ publicConfig: { DA_DOMAIN } }) =>
	createHttpClient(`${DA_DOMAIN}/api`, {
		credentials: "include",
		headers: {
			"Content-Type": "application/json",
		},
	});

export default daClient;
